import React from "react";
import { DesignSystemPage, DesignSystemSection, DesignSystemSectionRow } from "../DesignSystemHelpers";
import { ListItemWithSubLines } from "../../../designSystem/List/ListItemWithSubLines";
import { ButtonListItem, ListItem } from "../../../designSystem/List/ListItem";


export const ListItemOverview = (): JSX.Element =>
{
    
    return (       
        <DesignSystemPage>

            <DesignSystemSection title="ListItem">

                <DesignSystemSectionRow title="ListItem with icon and text">
                    <ListItem
                        leadingIcon="interface_user_user"
                        primaryText="John Johnson"
                    />
                </DesignSystemSectionRow>

                <DesignSystemSectionRow title="ListItem with icon and text and subtext">
                    <ListItem
                        leadingIcon="interface_user_user"
                        primaryText="John Johnson"
                        secondary={{text:"11223344"}}
                    />
                </DesignSystemSectionRow>

                <DesignSystemSectionRow title="ListItem with icon and text and subtext and subicon">
                    <ListItem
                        leadingIcon="interface_user_user"
                        primaryText="John Johnson"
                        secondary={{leadingIcon:"interface_glyph_phone", text:"11223344"}}
                    />
                </DesignSystemSectionRow>

                <DesignSystemSectionRow title="ListItem with icon and text and button">
                    <ListItem
                        leadingIcon="interface_user_user"
                        primaryText="John Johnson"
                        button={{variant:"filled", icon:"add_circle", onClick:()=>{alert("clicked")}}}
                    />
                </DesignSystemSectionRow>

                <DesignSystemSectionRow title="ListItem with icon and text and subtext and subicon and button">
                    <ListItem
                        leadingIcon="interface_user_user"
                        primaryText="John Johnson"
                        secondary={{leadingIcon:"interface_glyph_phone", text:"11223344"}}
                        button={{variant:"filled", icon:"add_circle", onClick:()=>{alert("clicked")}}}
                    />
                </DesignSystemSectionRow>

            </DesignSystemSection>

            <DesignSystemSection title="ButtonListItem">

                <DesignSystemSectionRow title="ButtonListItem with icon and text">
                    <ButtonListItem
                        leadingIcon="interface_user_user"
                        primaryText="John Johnson"
                    />
                </DesignSystemSectionRow>

                <DesignSystemSectionRow title="ButtonListItem with icon and text and subtext">
                    <ButtonListItem
                        leadingIcon="interface_user_user"
                        primaryText="John Johnson"
                        secondary={{text:"11223344"}}
                    />
                </DesignSystemSectionRow>

                <DesignSystemSectionRow title="ButtonListItem with icon and text and subtext and subicon">
                    <ButtonListItem
                        leadingIcon="interface_user_user"
                        primaryText="John Johnson"
                        secondary={{leadingIcon:"interface_glyph_phone", text:"11223344"}}
                    />
                </DesignSystemSectionRow>

                <DesignSystemSectionRow title="ButtonListItem with icon and text and button">
                    <ButtonListItem
                        leadingIcon="interface_user_user"
                        primaryText="John Johnson"
                        onClick={()=>{alert("clicked")}}
                    />
                </DesignSystemSectionRow>

                <DesignSystemSectionRow title="ButtonListItem with icon and text and subtext and subicon and button">
                    <ButtonListItem
                        leadingIcon="interface_user_user"
                        primaryText="John Johnson"
                        secondary={{leadingIcon:"interface_glyph_phone", text:"11223344"}}
                        onClick={()=>{alert("clicked")}}
                    />
                </DesignSystemSectionRow>

                <DesignSystemSectionRow title="with long text">
                    <div style={{width:200, border:'1px dotted gray'}}>
                        <ButtonListItem
                            leadingIcon="interface_user_user"
                            primaryText="this one has a veeeeeeeeeeeeeeeeeeeeery long nam that will be truncated"
                            secondary={{leadingIcon:"interface_glyph_phone", text:"11223344 and a lot more text that will be truncated"}}
                            onClick={()=>{alert("clicked")}}
                        />
                    </div>
                </DesignSystemSectionRow>

            </DesignSystemSection>

            <DesignSystemSection title="ListItemWithSubLines">
                
                <DesignSystemSectionRow title="no subitems">
                    <ListItemWithSubLines
                        leadingIcon="interface_user_user"
                        primaryText="John Johnson"
                        secondaryItems={[]}
                    />
                </DesignSystemSectionRow>

                <DesignSystemSectionRow title="1 subitem">
                    <ListItemWithSubLines
                        leadingIcon="interface_user_user"
                        primaryText="John Johnson"
                        secondaryItems={[
                            {leadingIcon:"interface_glyph_phone", text:"11223344"}
                        ]}
                    />
                </DesignSystemSectionRow>

                <DesignSystemSectionRow title="2 subitems">
                    
                    <ListItemWithSubLines
                        leadingIcon="interface_user_user"
                        primaryText="John Johnson"
                        secondaryItems={[
                            {leadingIcon:"interface_glyph_phone", text:"11223344"},
                            {leadingIcon:"interface_glyph_email", text:"asda@asfa.asd"}
                        ]}
                    />
                </DesignSystemSectionRow>

                <DesignSystemSectionRow title="2 subitems with button">
                    
                    <ListItemWithSubLines
                        leadingIcon="interface_user_user"
                        primaryText="John Johnson"
                        secondaryItems={[
                            {leadingIcon:"interface_glyph_phone", text:"11223344"},
                            {leadingIcon:"interface_glyph_email", text:"asda@asfa.asd"}
                        ]}
                        button={{variant:"filled", icon:"add_circle", onClick:()=>{alert("clicked")}}}
                    />
                </DesignSystemSectionRow>

                <DesignSystemSectionRow title="2 subitems with long text">
                    <div style={{width:200, border:'1px dotted gray'}}>
                        <ListItemWithSubLines
                            leadingIcon="interface_user_user"
                            primaryText="this one has a veeeeeeeeeeeeeeeeeeeeery long nam that will be truncated"
                            secondaryItems={[
                                {leadingIcon:"interface_glyph_phone", text:"11223344 and a lot more text that will be truncated"},
                                {leadingIcon:"interface_glyph_email", text:"asda@thisisaverylongdomainnamethatshouldbetruncatedaswell.asd"}
                            ]}
                        />
                    </div>

                </DesignSystemSectionRow>

            </DesignSystemSection>
        </DesignSystemPage>
    );
}

